<div class="processing-wrapper">
    <div class="ss-spinner page"></div>
</div>
